<template>
    <div class="moderation page-container">
        <PageContent :content="content" :scrolling="true" content-below-height="120px">
            <div class="button-container">
                <div class="mind2-button brown" @click="openFlyer">
                    <img src="../assets/Logo_Mind2_DrThumm_RZ_rgb_light.png">
                    <div>PDF Flyer</div>
                </div>
                <div class="mind2-button" @click="openMind2">
                    <img src="../assets/Logo_Mind2_DrThumm_RZ_rgb.png">
                    <div>Jetzt starten</div>
                </div>
            </div>
        </PageContent>
    </div>
</template>
<script>
    import mind from '../content/mind.json'
    import PageContent from "../components/PageContent";

    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: 'Dr Thumm GmbH' }
                ]
            }
        },
        data() {
            return {
                actualPage: 0,
                paginationFinish: false,
                fotoPapa: true,
                content: {
                    mind
                },
                paginationHeight: 0
            }
        },
        computed: {
            paginationStyle() {
                return {
                    height: `${this.paginationHeight}px`
                }
            },
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "")

                if (route.includes('historie')) this.fotoPapa = false
                else this.fotoPapa = true

                let content = this.content
                console.log(content.moderation)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })

                return content
            },
            pagination() {
                if (this.actualPage < 0) this.actualPage = 0
                else if (this.page.pagination[this.actualPage] === undefined) this.actualPage -= 1
                return this.page.pagination[this.actualPage]
            }

        },
        mounted() {
            this.getHighestPagination()
        },
        methods: {
            openFlyer() {
                window.open('https://dr-thumm.de/static/files/mind2Flyer_148x148mm_RZ.pdf')
            },
            openMind2() {
              window.open('https://mind2.dr-thumm.de')
            },
            getHighestPagination() {
                var maxHeight = Math.max.apply(null, $(".pagination-text p").map(function () {
                    return $(this).height();
                }).get());
                this.paginationHeight = maxHeight
                this.paginationFinish = true
            },
            changePage(page) {
                this.actualPage = page
                this.getHighestPagination()
            }
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass" scoped>

    .button-container
        display: flex

        > div
            flex: 1

    .content-text

        .mind2-button
            display: flex
            height: 60px
            align-items: center
            background: #F5F5F5
            width: 50%
            padding: 10px
            border-radius: 14px
            margin: 20px 5px
            justify-content: center
            cursor: pointer

            &.brown
                background: #815e4b
                color: #fff

                &:hover
                    background: #815e4bDD

            &:hover
                background: #eee


            img
                max-height: 80%
                margin-right: 10px

            div
                font-family: "GT Walsheim Regular"
                font-size: 24px





</style>